module.exports = __webpack_public_path__ + "static/media/rebirth_31.77abdcac.jpg";